export const BASE_URL = process.env.REACT_APP_BASE_URL;

export const API_END_POINTS = {
  login: BASE_URL + "auth/login",
  signup: BASE_URL + "student/signup",
  organizationSubmit: BASE_URL + "organization/submit",
  signupConfirmation: BASE_URL + "auth/verify-otp",
  resendOTP: BASE_URL + "auth/resend-otp",
  emailForgotPassword: BASE_URL + "auth/request-reset",
  resetPassword: BASE_URL + "auth/reset",
  getLoginResponse: BASE_URL + "auth/me",
  organizationTypeList: BASE_URL + "organization/industry-types",
  googleLogin: BASE_URL + "auth/google-login",
  facebookLogin: BASE_URL + "auth/facebook-login",

  // price plans
  getPlans: BASE_URL + "payments/plans",
  createPaymentIntent: BASE_URL + "payments/create-payment-intent",
  confirmPaymentIntent: BASE_URL + "payments/confirm-payment-intent",
  // stripe payments endPoints
  userSubscription: BASE_URL + "payments/user-subscription",
  subscribePlan: BASE_URL + "payments/subscribe",
  checkoutSession: BASE_URL + "payments/checkout-session",

  // global Data
  fieldOfStudy: BASE_URL + "common/field-of-study",
  skipClick: BASE_URL + "skip/click",
  getAllInstructors: BASE_URL + "admin/instructors",
  getAllCourses: BASE_URL + "course/get-all",
  getAllCategories: BASE_URL + "course/categories",


  // student
  studentCourses: BASE_URL + "student/courses",
  studentFavoriteCourse: BASE_URL + "student/favorites",
  studentEnrolledCourse: BASE_URL + "student/enrolled-courses",
  studentAllCourseCategories: BASE_URL + "student/categories",
  enrolledAllStudent: BASE_URL + "instructor/enrolledStudents",
  studentCompletedCourse: BASE_URL + "student/completed-courses",
  getAllstudentCourse: BASE_URL + "student/all-courses",
  getAllstudentCertificate: BASE_URL + "student/getallCertificate",
  getAllstudentCertificateRequests: BASE_URL + "student/certificate-requests",
  studentRequestCertificate: BASE_URL + "student/request-certificate",
  getAllStudentApprovedCertificate: BASE_URL + "student/approved-certificate",

  // instructor
  instructorProfileUpdate: BASE_URL + "instructor/setup-profile",
  instructorAddEducation: BASE_URL + "instructor/add-education",
  instructorAddExperience: BASE_URL + "instructor/add-experience",
  instructorStats: BASE_URL + "instructor/stats/dashboard",
  instructorStudents: BASE_URL + "instructor/students",
  instructorProfile: BASE_URL + "instructor/profile",
  instructorDeactivatedStudents: BASE_URL + "instructor/deactivated-students",
  updatePassword: BASE_URL + "common/auth/updatePassword",
  requestActivation: BASE_URL + "auth/request-activation",
  instructorUnpublishCourse: BASE_URL + "course/getUnpublish",
  instructorDeclineCourse: BASE_URL + "course/getDeclineCourses",

  adminCourses: BASE_URL + "admin/courses",
  adminAssignment: BASE_URL + "admin/assignments",
  clearNotifications: BASE_URL + "notifications/clear",

  // AI Endpoints
  studentAssessMe: BASE_URL + "student/assessme-ai",
  studentGrowthCoordinator: BASE_URL + "student/growth-coordinator",
  studentCertifyMe: BASE_URL + "student/certify-me",

  // Notebook endpoints (dynamic paths built at call site)
  studentNotebookBase: BASE_URL + "student/courses",
  adminNotebookBase: BASE_URL + "admin/students",

  // course
  instructorCourses: BASE_URL + "course/getCourses",
  instructorDraftCourse: BASE_URL + "course/getDraft",
  CourseCreation: BASE_URL + "course/create/new",
  CourseOption: BASE_URL + "course/options",
  uploadDocuments: BASE_URL + "course",
  
  //ans code
  //admin side integration of main dashboard page
  getAllOrganizationRequests: BASE_URL + "organization/requests",
  getAllStudents: BASE_URL + "admin/students",
  getUserById: BASE_URL + "admin/users",

  addExperience: BASE_URL + "admin/add-experience",
  updateExperience: BASE_URL + "admin/update-experience",
  deleteExperience: BASE_URL + "admin/delete-experience",
  addEducation: BASE_URL + "admin/add-education",
  updateEducation: BASE_URL + "admin/update-education",
  deleteEducation: BASE_URL + "admin/delete-education",

  studentAddExperience: BASE_URL + "student/add-experience",
  studentUpdateExperience: BASE_URL + "student/update-experience",
  studentDeleteExperience: BASE_URL + "student/delete-experience",
  studentAddEducation: BASE_URL + "student/add-education",
  studentUpdateEducation: BASE_URL + "student/update-education",
  studentDeleteEducation: BASE_URL + "student/delete-education",

  getDeactivatedUsers: BASE_URL + "admin/deactivated-users",
  activateUser: BASE_URL + "admin/users",
  deactivateUser: BASE_URL + "admin/users",
  // reviews
  deleteReview: BASE_URL + "admin/course/review",

  getAllCertificateByAdmin: BASE_URL + "admin/certificates/getAll",
  adminApprovedCertificate: BASE_URL + "admin/certificate-requests",
  adminRejectCertificate: BASE_URL + "admin/certificate-requests",

  // profile
  userProfileByAdmin: BASE_URL + "admin/users",
  userProfileUpdate: BASE_URL + "admin/updateProfile",
  commonCurriculum: BASE_URL + "common/curriculum",
  commonComment: BASE_URL + "common/comments",
  studentAssignment: BASE_URL + "student/assignments",

  studentVideos: BASE_URL + "student/videos",
  studentArticle: BASE_URL + "student/articles",

  //instructor course requests for instructor side
  pendingApprovalCourses: BASE_URL + "instructor/courses/pending-approval",
  unpublishedCoursesRequests:
    BASE_URL + "instructor/courses/unpublish-requests",

  //course creation requests for admin side
  pendingApprovalCoursesAdmin:
    BASE_URL + "admin/courses/pending-course-requests",
  approveCourse: BASE_URL + "admin/courses/:courseId/approve",
  rejectCourse: BASE_URL + "admin/courses/:courseId/reject",

  //course unpublished requests for admin side
  pendingUnpublishCoursesAdmin: BASE_URL + "admin/pending-unpublish-courses",
  approveUnpublishCourse:
    BASE_URL + "admin/courses/:courseId/approve-unpublish",
  rejectUnpublishCourse: BASE_URL + "admin/courses/:courseId/decline-unpublish",

  // notification preferences
  notificationPreferences: BASE_URL + "notification-preferences",
  notificationPreferencesReset: BASE_URL + "notification-preferences/reset",

  getAllCertificateByInstructor: BASE_URL + "instructor/certificate-requests",
  instructorApprovedCertificate: BASE_URL + "instructor/approve-certificate-request",
  instructorRejectCertificate: BASE_URL + "instructor/reject-certificate-request",
};
